import Swiper from './swiper.min.js';

console.log('###### main.js imported ######');

window.addEventListener('resize', () => {
  // ファーストビュー100vhのアドレスバーを除いた部分のpxを取得
  let vh = window.innerHeight * 0.01;
  // カスタム変数--vhの値をドキュメントのルートに設定
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

// YouTubeセクションのスライダー
let mySwiper = new Swiper('.swiper-container', {
  navigation: {  //ナビゲーションのオプション（矢印ボタンの要素を指定）
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  autoHeight: true,
  slidesPerView: 1.5,
  breakpoints: {
    768: {
      slidesPerView: 2
    },
    769: {
      slidesPerView: 3
    }
  }
});

// MENU開閉
const menuBtns = document.querySelectorAll('.hamburger-menu');
const menu = document.querySelector('.menu');
const html = document.querySelector('html');
const body = document.body;

menuBtns.forEach((menuBtn) => {

  menuBtn.addEventListener('click', () => {
    if(!menuBtn.classList.contains('hamburger-menu--open')) {
      menuBtn.classList.add('hamburger-menu--open');
      html.classList.add('menu--active');
    } else {
      menuBtn.classList.remove('hamburger-menu--open');
      html.classList.remove('menu--active');
    }
  });
});

// お問い合わせ確認ページ
// 必須ではない項目が空だった時、その項目をDOMから取り除く
const confirmForm = document.querySelector('.mw_wp_form_confirm');
if(confirmForm) {
  const labels = confirmForm.querySelectorAll('.mwwp-form__label');
  labels.forEach((label) => {
    if(label.nextElementSibling.value === '') {
      label.parentElement.remove();
    }
  });
}

// header
const header = document.querySelector('.header');
const headerHeight = 56;
let headerOffset = 0;
let headerLastPosition = 0;
let ticking = false;

function headerPosition() {
  if (window.pageYOffset > 300) {
    header.classList.add('header--scrolled');
  } else {
    header.classList.remove('header--scrolled');
  }
}

function onScroll() {
  if (headerLastPosition > headerHeight) {
    if (headerLastPosition > headerOffset) {
      header.classList.add('header--animated');
    } else {
      header.classList.remove('header--animated');
    }
    headerOffset = headerLastPosition;
  }
}

window.addEventListener('scroll', function(e) {
  headerPosition();
  headerLastPosition = window.scrollY;
  if (!ticking) {
    window.requestAnimationFrame(function() {
      onScroll(headerLastPosition);
      ticking = false;
    });
    ticking = true;
  }
});

